const ActionTypes = {
  SET_CURRENT_USER_ROLE: 'SET_CURRENT_USER_ROLE',
  FIND_AND_SET_CURRENT_USER_ROLE: 'FIND_AND_SET_CURRENT_USER_ROLE',
  DELETE_CURRENT_USER_ROLE: 'DELETE_CURRENT_USER_ROLE',
  REFRESH: 'REFRESH',
};

export default ActionTypes;


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/actions/CurrentRoleActionTypes.js